import {
  AppstoreOutline,
  CollectMoneyOutline,
  EditSOutline,
  FileOutline,
  RightOutline,
  UserOutline,
} from "antd-mobile-icons";

import HomeIcon from "@mui/icons-material/Home";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import CreateIcon from "@mui/icons-material/Create";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default [
  {
    path: "/staff/app",
    key: "home",
    title: "Home",
    icon: AppstoreOutline,
    muiIcon: HomeIcon,

    module: "any",
    action: "any",
    exact: true,
  },
  { title: "divider" },
  {
    path: "/staff/app/my-timetable",
    key: "my_time_table",
    title: "My Time Table",
    icon: CollectMoneyOutline,
    muiIcon: NewspaperIcon,
    module: "mob_student_attendance",
    action: "action_create",
    exact: true,
  },
  {
    path: "/staff/app/custom-attendance-entry",
    key: "general_entry",
    title: "General Entry",
    icon: EditSOutline,
    muiIcon: CreateIcon,
    module: "allow_staff_in_mobile_general_att_entry",
    action: "action_create",
    exact: true,
  },
  {
    path: "/staff/app/custom-attendance-entry/elective",
    key: "nm_sbe_entry",
    title: "NME, SBE Entry",
    icon: EditSOutline,
    muiIcon: CreateIcon,
    module: "mob_elective_atttendance",
    action: "action_create",
    exact: true,
  },
  {
    path: "/staff/app/custom-attendance-entry/special",
    key: "special_entry",
    title: "Special Entry",
    icon: EditSOutline,
    muiIcon: SaveAsIcon,
    module: "mob_att_special_entry",
    action: "action_create",
    exact: true,
  },
  {
    path: "/staff/app/atttendance-pending-list",
    key: "view_pendings",
    title: "View Pendings",
    icon: FileOutline,
    muiIcon: ArticleOutlinedIcon,
    module: "mob_allow_view_dept_pending_attendance",
    action: "action_read",
    exact: true,
  },
  { title: "divider" },
  {
    path: "/staff/app/fee-pending-list",
    key: "class_fee_pending",
    title: "Class Fee Pendings",
    icon: FileOutline,
    muiIcon: RequestPageOutlinedIcon,
    module: "mob_staff_view_class_pending",
    action: "action_list",
    exact: true,
  },
  {
    path: "/staff/app/myprofile",
    key: "my_profile",
    title: "Profile",
    icon: UserOutline,
    muiIcon: PersonOutlineOutlinedIcon,
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/lock_screen",
    key: "lock_screen",
    title: "Lock Screen",
    icon: RightOutline,
    muiIcon: LockOutlinedIcon,
    module: "any",
    action: "any",
    onclick: "lock",
    exact: true,
  },
];
